    <!-- not verify -->
    <div [id]="dataObj?.type" class="bg-white pl-3 py-3 pr-3 d-flex justify-content-between align-items-center position-relative container-shadow generic-card-container">
        <div class="w-75">
            <p class="paragraph-bold">{{dataObj?.heading_text}}</p>
            <p class="secondary-paragraph"><span class="color-grey-700">{{dataObj?.description_text}}</span></p>
            <button [id]="'profile_nudge_button-'+dataObj?.button?.text" *ngIf="dataObj?.button!=null" 
                class="cursor-pointer btn-design small filled px-3 mt-3" 
                (click)="showWebModal('verify_step1')" 
                [appAnalyticsEvent]="analyticsData">{{dataObj?.button?.text}}
            </button>
        </div>
        <img *ngIf="dataObj?.type=='generic'" 
            src="assets/themes/images/game-nudge.svg"
            width="140px" 
            alt="nudge guideline"/>
        <img *ngIf="dataObj?.type=='profile_incompleted'" 
            src="assets/themes/images/complete-profile-nudge.svg" width="120px"
            alt="Complete profile nudge"/>
    </div>
    <!--  end not verify -->
    
    <app-feed-detail-modal 
        *ngIf="feedDetailModal==true" 
        [feedDetailModal]="feedDetailModal" 
        (resetFeedDetailModal) = resetFeedDetailModal($event) 
        [mediaIdx]="mediaIdx" 
        [feedId]="product_id">
    </app-feed-detail-modal>